import React from 'react'
import DatePicker from 'material-ui/DatePicker';
import * as colors from "material-ui/styles/colors";

const IntlPolyfill = require('intl');
const DateTimeFormat = IntlPolyfill.DateTimeFormat;
require('intl/locale-data/jsonp/ja-JP');

class FormDatePicker extends  React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render () {
    
      const { input, label, meta: { touched, error }, dialogMonth, showWeek,onDismiss, ...custom } = this.props

      return (
        <DatePicker
          floatingLabelStyle={{color: colors.grey600}}
          floatingLabelFixed
          floatingLabelText={label}
          DateTimeFormat={DateTimeFormat}
          errorText={touched && error}
          formatDate={date => {
    
            let week = ''
            if (showWeek) {
              let dayOfWeek = date.getDay()
              let dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]
              week = ` (${dayOfWeekStr})`
            }
    
            return (date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate() + week)
    
          }}
    
          value={input.value !== '' ? new Date(input.value) : null}
    
          ref={(c) => this.picker = c}
          onShow={() => {
            if (dialogMonth) {
    
              if (this.picker.state.date === undefined) {
                this.picker.setState(Object.assign(this.picker.state, { dialogDate: dialogMonth }))
              }
    
            }
          }}
          onDismiss={() => {

            if (onDismiss) {
              onDismiss()
              return
            }

            if (window.confirm("日付をクリアします。よろしいですか？")) {
              input.onChange('')
            }

          }}
          // onFocus={() => {
          //   this.picker.setState(Object.assign(this.picker.state, { date: new Date(2017, 0, 1) }))
          // }}
    
          // onDismiss={() => {
          //   this.picker.setState(Object.assign(this.picker.state, { date: null }))
          // }}
          onChange={(event, value) => { input.onChange(value) }}
          {...custom}
        />
    )}

}

export default FormDatePicker


// WEBPACK FOOTER //
// ./src/components/FormDatePicker.js